import { mb } from '../../common/theme/mbTokens';

/**
 * The agenda's shared style tokens: one type scale, one muted colour, one set of surface sizes, so
 * the list, the cards, the strip and the panel read as one screen rather than five files.
 *
 * Body text is regular weight in the theme's warm muted colour.
 */
export const FONT_SIZE = {
  /** The customer's name: the one thing staff scan for. */
  title: '19px',
  /** Start–end times on cards and slot headers. */
  time: '15px',
  /** Everything inside an unfolded card. */
  body: '15px',
  /** Buttons and slot-header counts. */
  text: '15px',
  /** Counts, phone, filter buttons, messages. */
  secondary: '14px',
  /** Order number, area, horizon line. */
  detail: '14px',
  /** The now divider's label. */
  caption: '13px',
} as const;

export const BODY_WEIGHT = 400;
export const MUTED_TEXT = mb.muted;
export const ICON_SIZE = '20px';
export const CARD_RADIUS = '8px';
export const ACTION_SIZE = '40px';
/** Inner padding of an order card; the slot header's inline padding matches it so their text lines up. */
export const CARD_PADDING = { xs: '12px 14px', md: '18px 20px' };
export const CARD_PADDING_INLINE = { xs: '14px', md: '20px' };

/** Scrolls without drawing a bar beside the centred column; the wheel, trackpad and touch still work. */
export const HIDDEN_SCROLLBAR_SX = {
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': { display: 'none' },
} as const;

/** The phone's floating "+" (56px) plus its 16px inset: the list's bottom padding so the last card can clear it. */
export const PHONE_FAB_CLEARANCE = '72px';

/** Duration of the phone top folding away and coming back. */
export const PHONE_TOP_COLLAPSE_MS = 200;
